import { dataScopeSchema, type DataScope } from "../workflowData/models";
import { z } from "zod";
import { builderWorkflowSchema, workflowDraftSchema } from "../workflowBuilder/models";

export const homeCandidateSchema = z.object({
    id: z.string().min(1),
    kind: z.enum(["personal", "admin"]),
    title: z.string(),
    description: z.string(),
    data_scope: dataScopeSchema.nullish(),
    requires_project: z.boolean()
});
export const homeRouteSchema = z
    .object({
        action: z.enum(["answer", "start", "choose", "create"]),
        data_intent: z.enum(["workspace_card_count"]).nullish(),
        input: z.string(),
        project_id: z.string().min(1).nullable(),
        question: z.string(),
        candidates: z.array(homeCandidateSchema)
    })
    .superRefine((route, context) => {
        if (
            (route.action === "start" && route.candidates.length !== 1) ||
            (route.action === "choose" && route.candidates.length < 2) ||
            ((route.action === "answer" || route.action === "create") && route.candidates.length !== 0)
        ) {
            context.addIssue({ code: "custom", message: "Invalid Home workflow decision" });
        }
        if (route.data_intent && route.action !== "answer") {
            context.addIssue({ code: "custom", message: "A data intent requires an answer route" });
        }
    });
export const personalRunSchema = z.object({
    id: z.string(),
    workflow_id: z.string(),
    title: z.string(),
    workflow: builderWorkflowSchema,
    input: z.string(),
    preview: workflowDraftSchema.shape.preview.unwrap().pick({ boxes: true }).nullable(),
    data_scope: dataScopeSchema.nullish(),
    project_id: z.string().nullable(),
    project_name: z.string().nullable(),
    revision: z.number().int(),
    status: z.enum(["processing", "completed", "failed"]),
    error: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string()
});
export type HomeCandidate = z.infer<typeof homeCandidateSchema>;
export type HomeRoute = z.infer<typeof homeRouteSchema>;
export type PersonalRun = z.infer<typeof personalRunSchema>;
export type HomeFlow = { message: string; route: HomeRoute };
export type RunRequest = {
    request_id: string;
    workflow_id: string;
    message: string;
    language: string;
    project_id: string | null;
    data_scope?: DataScope | null;
    run_id?: string;
    expected_revision?: number;
};
